import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { FeatureCode, ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { AccountViewModel } from '../../../business-entities/account-view-model';
import { CityModel, CustomerModel } from '../../../business-entities/customer-view.model';
import { Features } from '../../../business-entities/user-role-view-model';
import { CustomerService } from '../../../business-services/customer.service';
import { SettingService } from '../../../business-services/setting.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import * as Enums from "projects/Autofacets-Core/src/app/utils/enums";
import { CountryISO } from 'ngx-intl-tel-input-gg';



const AddAccountTabs: { id: number, label: string, route: string } [] = [
  { id: 1, label: 'lblAddAccount', route: 'add-account' }
]

@Component({
  selector: 'app-add-account',
  templateUrl: './add-account.component.html',
})
export class AddAccountComponent implements OnInit {
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  accountId: string;
  noOfTabLimit: number = 1;
  selectedtab: number = 1;
  accountForm: FormGroup;
  accountDetail: AccountViewModel;
  popupCloseResult = false;
  userMobileCode: string;
  isFormValid: boolean = false;
  countryList: any;
  countryId: number;
  postcodeName: string;
  cityName: string;
  countryName: string;
  userPhoneNumberCode: string;
  iscountryRequired: boolean;
  iscityRequired: boolean;
  cityList: CityModel[];
  postCodeRawData: any;
  postCodeList: any;
  ispostcodeRequired: boolean;
  addressSalutationList: any;
  salutationName: string;
  registrationDate: string;
  endDate: string;
  iscustomergroupRequired: boolean;
  customerGroupList: any;
  customergroupName: string;
  isCompanynameRequired: boolean;
  features: Features[] = [];
  responseResult: any;
  validstring: any;
  isAddress1Required: boolean;
  postcodeRequired: boolean;
  cityRequired: boolean;
  countryRequired: boolean;
  isEmailRequired: boolean;
  isPhoneRequired: boolean;

  constructor(
    private readonly service: CustomerService,
    private readonly activeModal: NgbActiveModal,
    private readonly formBuilder: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly spinner: NgxSpinnerService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly toaster: ToastrService,
    private readonly secureStorage: SecureStorage,
    private readonly settingService: SettingService,
    private readonly translate: TranslateService) { }

  ngOnInit(): void {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this.getValidateConfig();

    this.accountForm = this.formBuilder.group({
      accountName: ['', [Validators.required]],
      accountNo: [''],
      registrationNumber: ['', [Validators.required]],
      registrationDate: ['', [Validators.required]],
      salutation: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: [''],
      postcode: ['', [Validators.required]],
      city: ['', [Validators.required]],
      isActive: [true],
      country: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(Enums.RegexKeyCollection.Email)]],
      mobile: ['', [Validators.required, Validators.pattern(/^\d{8,11}$/)]],
    })
    this.getAddressSalutationDropdown();
    this.countryDropdownDetails();
    this.getPostCodeDropdown();
    this.getFeatures();
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
  }

  OnClose() {
    this.activeModal.close({ success: false });
  }

  tabSelected(id) {
    this.selectedtab = id;
  }

  tabs: { id: number, label: string, route: string }[] = AddAccountTabs;

  get cpf() {
    return this.accountForm.controls;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  CheckMobileNumeber(value) {
    if (this.accountDetail)
      if (value.target.value != this.accountDetail?.mobileNo && value.target.value) {
        let modelHeadermsg = this.translate.instant("lblAlert");
        let modelBodymsg = this.translate.instant("lblMobileNoAlertMsg");
        modelBodymsg = modelBodymsg?.replace('{customer}', this.accountDetail?.customerName);
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
           // This is intentional
        }, (reason) => {
          this.popupCloseResult = this.getDismissReason(reason);
        });
      }
  }

  onCountryChange(obj3) {
    if (this.isInitialLoad) {
    this.telInputObject();
    this.userMobileCode = this.userMobileCode || obj3.dialCode;
    this.isInitialLoad = false;
    } else {
      this.userMobileCode = obj3.dialCode;
    }
  }

  async onCitySelected(city: any) {
    this.cityName = city;
    if (city?.trim()) {
      this.BindPostData(city);
      this.BindCountryBasedCity(city);
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.postcodeName = "";
      this.accountForm.patchValue({
        country: ''
      })
    }
  }

  async getPostCodeDropdown() {
    this.spinner.show();
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("");
      this.BindCityData("");
    } 
    this.spinner.hide();
  }

  BindPostData(city) {
    if (city?.trim()) {
      this.postCodeList = this.postCodeRawData.filter(f => f.city == city);
      if (this.postcodeName?.length === 0) {
        this.postcodeName = this.postCodeList[0]?.code;
      }
    } else {
      this.postCodeList = this.postCodeRawData;
    }
  }

  async getCustomerGroup() {
    this.spinner.show();
    await this.service.GetCustomerGroupDropdown().then((response) => {
      this.customerGroupList = response.responseObject.filter(x => x.isDisplay);
      this.customerGroupList = this.customerGroupList.sort((a, b) =>
        (b?.code || '').localeCompare(a?.code || '')
      );
    } ,_error => {
      this.spinner.hide();
    });

  }

  BindCountryBasedCity(city) {
    let postdata = this.postCodeRawData.filter(f => f.city == city)
    let countryCode = postdata.map(item => item.countryCode).filter((value, index, self) => self.indexOf(value) === index);
    let selectedCountry = this.countryList.filter(f => f.code === countryCode[0])
    this.countryName = selectedCountry[0]?.countryName;
    this.countryId = selectedCountry[0]?.id;
  }

  telInputObject() {
      if (this.userMobileCode) {
        this.userMobileCode = this.userMobileCode.replace('+', '');
        let countryCode = this.getCountryCodeByDialCode(this.userMobileCode);
        this.selectedCountryISO= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
      this.selectedCountryISO= this.cultureLocaleService.getLocale();
  }  

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  async getAddressSalutationDropdown() {
    if(!this.addressSalutationList?.length){
    await this.service.GetAddressSalutationDropdown().then((response) => {
      this.addressSalutationList = response != null ? response.responseObject : [];
    }, _error => {
      this.spinner.hide();
    });
  }
}

  onselectCountry(event): void {
    this.countryId =  event ?? 0;

    if (this.countryId > 0) {
      let obj = this.countryList?.filter(f => f.id == this.countryId);
      this.selectedCountryISO= obj[0]?.code?.toLowerCase();

      this.countryName = obj[0]?.countryName;
      this.userMobileCode = obj[0]?.mobileCode;
      this.userPhoneNumberCode = obj[0]?.mobileCode;
    } else {
      let local = this.cultureLocaleService.getLocale();
      let obj = this.countryList?.filter(f => f.code == local.toUpperCase());
      this.selectedCountryISO=  local;

      this.countryName = obj[0]?.countryName;
      this.countryId = obj[0]?.id;
      this.userMobileCode = obj[0]?.mobileCode;
      this.userPhoneNumberCode = obj[0]?.mobileCode;
      this.cityName = "";
      this.postcodeName = "";
    }
  }

  BindCityData(post) {
    if (post?.trim()) {
      let postdata = this.postCodeRawData.filter(f => f.code == post);
      this.cityList = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.onCitySelected(this.cityList[0])
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  BindCountry(postCode) {
    let postdata = this.postCodeRawData.filter(f => f.code == postCode);
    let countryCode = postdata.map(item => item.countryCode).filter((value, index, self) => self.indexOf(value) === index);
    let selectedCountry = this.countryList.filter(f => f.code === countryCode[0])
    this.onselectCountry(selectedCountry[0]?.id);
  }

  async onPostCodeSelected(postCode: string) {
    this.postcodeName = postCode;
    if (postCode?.trim()) {
      this.BindCityData(postCode);
      this.BindCountry(postCode)
    } else {
      this.postCodeList = this.postCodeRawData;
      this.cityName = "";
      this.accountForm.patchValue({
        country: ''
      })
    }
  }

  async countryDropdownDetails(): Promise<void> {
    await this.service.getCountryCodeAndMobileCodeDetails()
      .then((response) => {
        this.countryList = response?.responseObject?.result.filter(x => x.isDisplay);

        let local = this.cultureLocaleService.getLocale();
        if (this.countryId != undefined) {
          let obj = this.countryList?.filter(f => f.id == this.countryId);
          this.selectedCountryISO=  obj[0]?.code?.toLowerCase();

          this.countryName = obj[0]?.countryName;
          this.userMobileCode = obj[0]?.mobileCode;
          this.userPhoneNumberCode = obj[0]?.mobileCode;
        } else {
          let obj = this.countryList?.filter(f => f.code == local.toUpperCase());
          this.selectedCountryISO= local;

          this.countryName = obj[0]?.countryName;
          this.countryId = obj[0]?.id;
          this.userMobileCode = obj[0]?.mobileCode;
          this.userPhoneNumberCode = obj[0]?.mobileCode;
        }

        setTimeout(() => {
          this.spinner.hide();
        }, 2000);
      }, _error => {
        this.spinner.hide();
      });
  }

  async AddEditAccount() {
      if (!this.accountForm.valid) {
        this.isFormValid = true;
        return;
      }
      this.isFormValid = false;
      let customerInfo =
      {
        customerId: 0,
        firstName: "",
        lastName: "",
        custName: this.empty(this.accountForm.get('accountName').value) ?  "" : this.accountForm.get('accountName').value,
        accountCompanyName: "" ,
        address1: this.empty(this.accountForm.get('address1').value) ? "" : this.accountForm.get('address1').value,
        address2: this.empty(this.accountForm.get('address2').value) ? "" : this.accountForm.get('address2').value,
        zipcode: this.empty(this.accountForm.get('postcode').value) ? "" : this.accountForm.get('postcode').value,
        city: this.empty(this.accountForm.get('city').value) ? "" : this.accountForm.get('city').value,
        state: "",
        countryId: this.countryId,
        mobileNo: this.accountForm.get('mobile').value?.number ? this.accountForm.get('mobile').value.number.toString().replace(/\s+/g, '') : this.accountForm.get('mobile').value,
        mobileCode: this.empty(this.userMobileCode) ? "" : this.userMobileCode.replace("+", ""),
        email: this.accountForm.get('email').value,
        latitude: 0,
        longitude: 0,
        customerNo: "",
        langaugeCode: "",
        blocked: this.accountForm.get('isActive').value ? 0 : 1,
        phoneNumberCode: "",
        phoneNumber: "",
        customerTypeId: 0,

        registrationOrPersonNumber: this.accountForm.get('registrationNumber').value,

        registrationOrBirthDate: null,
        customerGroup: null,
        salutation: this.empty(this.accountForm.get('salutation').value) ? "" : this.accountForm.get('salutation').value,
        email2: "",
        fax: "",
        ownerTypeId: 0,
        sourceTypeId: 1,
        isActive: this.accountForm.get('isActive').value,
        isRegularEmail: false,
        isEmail: false,
        isFax: false,
        isSms: false,
        isPhone: false,
        dataPrivacyStatus: 1,
        integrationWithDMS: false,
        moduleId: ModuleNames.Customer,
        countryCode: this.countryList?.find(f => f.id == this.countryId).code,
        generateCustomerNoPlannerSide: false,
        realtimeDmsSyncCustomer: true,
        isAccountHolderCompany: true,
        isAddAccount: true,
        isMarketingConsent:false,
        contactId:"",
        customerDisagreement:false,
        paymentMethodCode:"",
        paymentTermsCode:"",
        reminderTermsCode:"",
        preferredDealerId:"",
      }
      customerInfo.registrationOrPersonNumber = this.accountForm.get('registrationNumber').value;
      const temp = new Date();
      if (!this.empty(this.accountForm.get('registrationDate').value)) {
        let registerdate = new Date(Utility.getDateStringToDate(this.accountForm.get('registrationDate').value).getTime() - (temp.getTimezoneOffset() * 60000));
        customerInfo.registrationOrBirthDate = registerdate;
      } else {
        customerInfo.registrationOrBirthDate = "";
      }
      this.service.customerMobileNo = this.accountForm.get('mobile').value?.number ? this.accountForm.get('mobile').value.number.toString().replace(/\s+/g, '') : this.accountForm.get('mobile').value;
      if (this.features && this.features.length > 0) {
        let feature = this.features.find(x => x.featureCode === FeatureCode.DMS)?.isActive
        customerInfo.integrationWithDMS = feature;
        let featureGenerate = this.features.find(x => x.featureCode === FeatureCode.GCuNoPlannerSide)?.isActive
        customerInfo.generateCustomerNoPlannerSide = featureGenerate;
        let realTimeSync = this.features.find(x => x.featureCode === FeatureCode.RTDSC)?.isActive
        customerInfo.realtimeDmsSyncCustomer = realTimeSync;
      }
      this.SaveUpdateAccount(customerInfo);
   }

  async SaveUpdateAccount(customerInfo: CustomerModel) {
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")

    let successMessage = "";
    successMessage = this.translate.instant("lblAccountAddedSuccessfully");
    this.spinner.show();
    this.service.addEditCustomer(customerInfo).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.responseResult = res.responseObject;
        if (this.responseResult.isSuccess) {
          this.activeModal.close({ success: true });

        } else {
          successMessage = this.responseResult.resultMessage;
        }
        this.toaster.success(successMessage);
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        let errormsg = this.translate.instant("lblAlreadyAdded");
        this.toaster.warning(errormsg);
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toaster.warning(WarningMessage);
      }
      else {
        this.toaster.error(errorMessage);
      }
    });
  }

  async getValidateConfig() {
    this.settingService.getFieldConfiguration("Account").then((res) => {
      if (res.responseObject) {
        this.validstring = res.responseObject;
        if (!isNullOrUndefined(this.validstring)) {
          this.updateFieldValidity("address1" );
          this.updateFieldValidity("postcode");
          this.updateFieldValidity("city" );
          this.updateFieldValidity("country");
          this.updateFieldValidity("email");
          this.updateFieldValidity("phone");
        }
      }

      this.accountForm = this.formBuilder.group({
        accountName: ['', [Validators.required]],
        accountNo: [''],
        registrationNumber: ['', [Validators.required]],
        registrationDate: ['', [Validators.required]],
        salutation: ['', [Validators.required]],
        address1: ['', (this.isAddress1Required ? [Validators.required] : null)],
        address2: [''],
        postcode: ['', (this.postcodeRequired ? [Validators.required] : null)],
        city: ['', (this.cityRequired ? [Validators.required] : null)],
        isActive: [true],
        country: ['', (this.countryRequired ? [Validators.required] : null)],
        email: ['', (this.isEmailRequired ? [Validators.required, Validators.pattern(Enums.RegexKeyCollection.Email)] : null)],
        mobile: ['', (this.isPhoneRequired ? [Validators.required] : null)],
      });
    
      this.getAddressSalutationDropdown();
      this.getFeatures();
    });
  }

  updateFieldValidity(fieldName){
    const fieldValid = this.validstring.find(x => x.columnName === fieldName);
  if (!isNullOrUndefined(fieldValid)) {
    this[fieldName + "Required"] = fieldValid.isRequired;
  }
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  onMobileChange(){
    if(this.accountForm.get('mobile').value){
      let len= this.accountForm.get('mobile').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>11){
        this.accountForm.get('mobile').setValidators([Validators.required, Validators.pattern(/^\d{8,11}$/)]);
        this.accountForm.get('mobile').updateValueAndValidity();
      } else {
        this.accountForm.get('mobile').setValidators([Validators.required]);
        this.accountForm.get('mobile').updateValueAndValidity();
      }
    } 
  }

}
